var WarmupQuestions = require("lib/academic/WarmupQuestions");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

class NonFictionSubjectQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionSubjectQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [ENTITY_1_STAGE];
		}

		if (!answers[ENTITY_1]) {
			return [ENTITY_1_STAGE];
		}

		if (!answers[ENTITY_2_TYPE] || !answers[ENTITY_2]) {
			return [ENTITY_2_STAGE];
		}

		if (this.props.level == "1") {
			return [ENTITY_2_STAGE, true];
		}

		if (!answers[RELATIONSHIP]) {
			return [RELATIONSHIP_STAGE];
		}

		return [RELATIONSHIP_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var entity1Display = (
			<div>
				{ this.props.getTextF("label1", ENTITY_1_STAGE) }
				{ this.props.renderInputF(ENTITY_1) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			var answers = this.props.answers[NonFictionSubjectQuestion.STEM];
			var entity1 = answers[ENTITY_1];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.ENTITY1] = entity1;

			var entity2Display = (
				<div>
					{ this.props.getTextF("label1", ENTITY_2_STAGE) }
					{ this.props.renderDropdownF("choices1", ENTITY_2_STAGE, ENTITY_2_TYPE, [ENTITY_1]) }
					{ this.props.getTextF("label2", ENTITY_2_STAGE, replacementsHash) }
					{ this.props.renderInputF(ENTITY_2) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			var entity2 = answers[ENTITY_2];
			replacementsHash[WarmupQuestions.ENTITY2] = entity2;

			if (this.props.answers[TopicQuestion.STEM]) {
				var entity1Type = this.props.answers[TopicQuestion.STEM][TopicQuestion.MAIN_ENTITY];				
			} else {
				var entity1Type = "MISSING ENTITIY";
			}
			var entity2Type = answers[ENTITY_2_TYPE];
			replacementsHash[WarmupQuestions.RELATION_KEY] = [entity1Type, entity2Type].sort().join("_");

			var relationshipDisplay = (
				<div>
					{ this.props.getTextF("label1", RELATIONSHIP_STAGE, replacementsHash) }
					{ this.props.renderDropdownF("choices1", RELATIONSHIP_STAGE, RELATIONSHIP, undefined, replacementsHash) }
					{ this.props.getTextF("label2", RELATIONSHIP_STAGE, replacementsHash) }.
				</div>
			);
		}

		return (
			<div>
				{ entity1Display }
				{ entity2Display }
				{ relationshipDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionSubjectQuestion.STEM = "nfsubj";

// stages
var ENTITY_1_STAGE = "entity1";
var ENTITY_2_STAGE = "entity2";
var RELATIONSHIP_STAGE = "relationship";

var STAGES = [
	ENTITY_1_STAGE, ENTITY_2_STAGE, RELATIONSHIP_STAGE
];

// answer keys
var ENTITY_1 = "entity_1";
var ENTITY_2_TYPE = "entity_2_type";
var ENTITY_2 = "entity_2";
var RELATIONSHIP = "relationship";

NonFictionSubjectQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionSubjectQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionSubjectQuestion.js